


































import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "Home"
})
export default class Home extends Vue {}
